export class ResidentialModel {

    private _ascensore: string;
    private _classeEnergetica: string;
    private _arredato: string;
    private _planimetrie: string;
    private _postoAuto: string;
    private _cantina: string;
    private _ripostiglio: string;
    private _solaio: string;

    public Id_Pratica: string;
    public N_Pratica: string;
    public Tipologia: string;
    public Localita: string;
    public Comune: string;
    public Data_Inserimento: any;
    public Data_Aggiornamento: any;
    public Opzione: string;
    public get Opzione_Estesa(): string {
        switch (this.Opzione) {
            case 'A': return 'Aff.';
            case 'O': return 'Ven./Aff.';
            default: return 'Ven.';
        }
    }
    public In_Costruzione: string;
    public Anno: number;
    public Piano: string;
    public Piani_Edificio: number; 
    public get PianoXdiY(): string {

        let temp = this.Piano;

        if (this.Piani_Edificio > 0)
            temp += ' / ' + this.Piani_Edificio;

        return temp;
    }
    public get Ascensore(): string {
        return this.formatStrBool(this._ascensore);
    }
    public set Ascensore(value: string) {
        this._ascensore = value;
    }
    public Mq_Commerciali: number;
    public Mq_Calpestabili: number;
    public get Superficie(): string {

        let temp = '';

        if (this.Mq_Commerciali && this.Mq_Commerciali)
            temp = this.Mq_Commerciali.toLocaleString('it-IT', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            });

        if (this.Mq_Calpestabili && this.Mq_Calpestabili > 0)
            temp += ' / ' + this.Mq_Calpestabili.toLocaleString('it-IT', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            });        

        return temp;
    }
    public Riscaldamento: string;
    public Condizionamento: string;
    public Stato_Immobile: string;
    public Stato_Impianti: string;
    public get Classe_Energetica(): string {

        if (this._classeEnergetica)
        {
            if ('01' == this._classeEnergetica || '02' == this._classeEnergetica)
                return 'Esente';

            return this._classeEnergetica;
        }

        return '';
    }
    public set Classe_Energetica(value: string) {
        this._classeEnergetica = value;
    }
    public IPE: number;
    public Vani: number;
    public get Arredato(): string {
        if ('T' == this._arredato)
            return 'Sì';
        else
        if ('P' == this._arredato)
            return 'Semi';        
    
        return '';
    }
    public set Arredato(value: string) {
        this._arredato = value;
    }
    public get Planimetrie(): string {
        return this.formatStrBool(this._planimetrie);
    }
    public set Planimetrie(value: string) {
        this._planimetrie = value;
    }
    public Camere: string;
    public Ingresso: string;
    public Soggiorno: string;
    public Cucina: string;
    public Bagni: string;
    public Balconi: string;
    public Garage: string;
    public get Posto_Auto(): string {
        return this.formatStrBool(this._postoAuto);
    }
    public set Posto_Auto(value: string) {
        this._postoAuto = value;
    }
    public get Cantina(): string {
        return this.formatStrBool(this._cantina);
    }
    public set Cantina(value: string) {
        this._cantina = value;
    }
    public get Ripostiglio(): string {
        return this.formatStrBool(this._ripostiglio);
    }
    public set Ripostiglio(value: string) {
        this._ripostiglio = value;
    }
    public get Solaio(): string {
        return this.formatStrBool(this._ripostiglio);
    }
    public set Solaio(value: string) {
        this._solaio = value;
    }
    public Mq_Mansarda: number;
    public Mq_Taverna: number;
    public Mq_Giardino: number;

    public Descrizione: string;    
    public Note: string;
    public Finiture_Interne: string;
    public Finiture_Esterne: string;

    public Spese: string;
    public Prezzo_Mandato: number;
    public Prezzo_Trattabile: number;
    public Prezzo_Vendita: number;
    public Condizioni_Contrattuali: string;
    public Deposito_Cauzionale: string;
    public Prezzo_Affitto: number;
    public Proprietario_Nome: string;
    public Proprietario_Referente: string;
    public Proprietario_Tel1: string;
    public Proprietario_Tel1_Label: string;
    public Proprietario_Tel2: string;
    public Proprietario_Tel2_Label: string;
    public Proprietario_Tel3: string;
    public Proprietario_Tel3_Label: string;
    public Proprietario_Cell: string;
    public Proprietario_Cell_Label: string;
    public Proprietario_Fax: string;
    public Proprietario_Fax_Label: string;
    public Proprietario_Email: string;
    public Cantiere_Impresa: string;
    public Cantiere_Referente: string;
    public Cantiere_Tel1: string;
    public Cantiere_Tel2: string;
    public Cantiere_Fax: string;
    public Cantiere_Email: string;
    public Cantiere_Responsabile: string;
    public Cantiere_Responsabile_Cell: string;
    public Cantiere_Inizio_Lavori: any;
    public Cantiere_Fine_Lavori: any;
    public Cantiere_Riferimento_Costruttore: string;
    public Cantiere_Fabbricato: string;
    public Cantiere_Quantita: number;
    public Cantiere_Unita_Adiacenti: string;

    public Occupato: string;
    public Inquilino_Nome: string;
    public Inquilino_Tel: string;
    public Inquilino_Tel_Label: string;
    public Libero_Data: any;

    public Visite: string;
    public Visto_Da: string;

    public Esclusiva: string;
    public Inizio_Mandato: any;
    public Fine_Mandato: any;
    public Sospeso: string;
    public Storicizzato: string;

    public get Stato(): string {

        if ('T' == this.Storicizzato)
            return 'Storicizzato';

        if ('T' == this.Sospeso)
            return 'Sospeso';

        return 'Attivo';
    }

    constructor(data: any = null) {

        if (data) {
            for (var property in data)
                this[property] = data[property];
        }
    }

    public isEmpty(property: string) {

        return (!this[property] || '' == this[property])
    }

    private formatStrBool(value: string): string {
        if ('T' == value)
            return 'Sì';

        return '';
    }
}


// WEBPACK FOOTER //
// ./src/models/residential.model.ts